const productData = [
  {
    id: 1,
    name: "hetcratehub Canned Cat Food - Free Range Chicken Pâté",
    category: "Cat Food",
    price: "2.2",
    reviews: "342",
    rating: "4.6",
    image: "/img/products/product-01.webp",
    images: ["/img/products/product-01.webp"],
    description: [
      "hetcratehub Free Range Chicken Pâté is a premium canned cat food crafted with real free-range chicken as the first ingredient.",
      "This gourmet pâté texture is perfect for cats of all life stages, providing complete and balanced nutrition in every bite.",
      "Made with wholesome ingredients including vegetables, fruits, and added vitamins and minerals to support your cat's overall health.",
      "The smooth, velvety texture makes it easy for cats to eat and digest, appealing even to the pickiest eaters.",
      "Convenient 156g cans ensure freshness and make portion control simple for daily feeding.",
    ],
    Features: [
      "Real free-range chicken as the #1 ingredient",
      "Grain-free formula for sensitive stomachs",
      "Rich in protein to support lean muscle mass",
      "Enhanced with omega fatty acids for healthy skin and coat",
      "No artificial preservatives, colors, or flavors",
      "Made in Canada with locally sourced ingredients",
    ],
  },
  {
    id: 2,
    name: "hetcratehub Wet Cat Food - Rabbit Recipe",
    category: "Cat Food",
    price: "4.19",
    reviews: "289",
    rating: "4.7",
    image: "/img/products/product-02.webp",
    images: ["/img/products/product-02.webp"],
    description: [
      "hetcratehub Rabbit Recipe is a premium wet cat food featuring deboned rabbit as the primary protein source.",
      "This grain-free formula is designed to provide cats with a taste they love while meeting their nutritional needs.",
      "Made with real whole foods including sweet potatoes, peas, and apples for added nutrition and flavor.",
      "The chunky pate texture offers a satisfying dining experience that cats find irresistible.",
      "Crafted in small batches with care to ensure quality and consistency in every can.",
    ],
    Features: [
      "Deboned rabbit #1 ingredient",
      "Grain-free and gluten-free recipe",
      "Real whole food ingredients",
      "No artificial preservatives or by-products",
      "High protein formula for muscle health",
      "Antioxidant-rich with vitamins A and E",
    ],
  },
  {
    id: 3,
    name: "hetcratehub Canned Cat Food - Indoor Chicken Pâté",
    category: "Cat Food",
    price: "2.2",
    reviews: "214",
    rating: "4.5",
    image: "/img/products/product-03.webp",
    images: ["/img/products/product-03.webp"],
    description: [
      "hetcratehub Indoor Chicken Pâté is specially formulated for indoor cats with a focus on hairball management and weight control.",
      "This premium canned food features real chicken as the primary ingredient, providing excellent taste and nutrition.",
      "Enhanced with dietary fiber to help reduce hairball formation and promote healthy digestion.",
      "Lower calorie formula helps maintain ideal body weight for less active indoor cats.",
      "Fortified with essential vitamins, minerals, and antioxidants to support a healthy immune system.",
    ],
    Features: [
      "Real chicken as first ingredient",
      "Formulated for indoor cats",
      "Helps control hairballs naturally",
      "Weight management formula",
      "Rich in fiber for digestive health",
      "Complete and balanced nutrition",
    ],
  },
  {
    id: 4,
    name: "hetcratehub Wet Cat Food - Chicken Recipe",
    category: "Cat Food",
    price: "2.89",
    reviews: "178",
    rating: "4.6",
    image: "/img/products/product-04.webp",
    images: ["/img/products/product-04.webp"],
    description: [
      "hetcratehub Chicken Recipe is a premium wet cat food featuring deboned chicken as the main ingredient.",
      "This carefully crafted formula provides cats with the protein they need while delivering exceptional taste they'll love.",
      "Made with simple, wholesome ingredients without artificial preservatives or fillers.",
      "The smooth pate texture is perfect for cats of all ages and helps encourage proper hydration.",
      "Supports healthy skin and coat with added omega fatty acids and zinc.",
    ],
    Features: [
      "Deboned chicken #1 ingredient",
      "Grain-free recipe",
      "No artificial preservatives or colors",
      "Added omega fatty acids",
      "Promotes healthy skin and coat",
      "Made with real, whole ingredients",
    ],
  },
  {
    id: 5,
    name: "hetcratehub Wet Cat Food - Duck Recipe",
    category: "Cat Food",
    price: "4.19",
    reviews: "305",
    rating: "4.8",
    image: "/img/products/product-05.webp",
    images: ["/img/products/product-05.webp"],
    description: [
      "hetcratehub Duck Recipe features high-quality duck as the primary protein source for cats who need variety in their diet.",
      "This grain-free wet cat food is packed with real duck and wholesome vegetables for complete nutrition.",
      "Perfect for cats with poultry sensitivities or those looking for a novel protein option.",
      "The delicious recipe is crafted in small batches to ensure quality and safety.",
      "Provides excellent hydration through moisture-rich wet food format.",
    ],
    Features: [
      "Real duck as #1 ingredient",
      "Grain-free and gluten-free",
      "Novel protein source",
      "Moisture-rich for hydration",
      "No artificial preservatives",
      "Supports healthy digestion",
    ],
  },
  {
    id: 6,
    name: "hetcratehub Wet Cat Food - Turkey Recipe",
    category: "Cat Food",
    price: "2.89",
    reviews: "198",
    rating: "4.4",
    image: "/img/products/product-06.webp",
    images: ["/img/products/product-06.webp"],
    description: [
      "hetcratehub Turkey Recipe is a hearty wet cat food made with real turkey as the leading ingredient.",
      "This protein-rich formula supports healthy muscle development and maintains energy levels.",
      "Made with farm-raised turkey and nutrient-dense vegetables for a balanced diet.",
      "The smooth pate texture appeals to even the most finicky feline eaters.",
      "Free from grains, corn, wheat, and soy for sensitive stomachs.",
    ],
    Features: [
      "Farm-raised turkey #1 ingredient",
      "High protein content",
      "Grain-free formula",
      "No corn, wheat, or soy",
      "Fortified with vitamins and minerals",
      "Promotes lean muscle health",
    ],
  },
  {
    id: 7,
    name: "hetcratehub Canned Cat Food - Ocean Fish Pâté",
    category: "Cat Food",
    price: "2.2",
    reviews: "240",
    rating: "4.7",
    image: "/img/products/product-07.webp",
    images: ["/img/products/product-07.webp"],
    description: [
      "hetcratehub Ocean Fish Pâté combines a medley of ocean fish including salmon, tuna, and whitefish for a flavor cats adore.",
      "This omega-rich formula supports healthy skin, a shiny coat, and overall feline wellness.",
      "Made with real seafood and fortified with essential nutrients for complete and balanced nutrition.",
      "The silky smooth pâté texture is easy to eat and highly palatable for all cats.",
      "An excellent choice for cats who enjoy fish-based diets.",
    ],
    Features: [
      "Blend of real ocean fish",
      "Rich in omega-3 and omega-6 fatty acids",
      "Promotes healthy skin and coat",
      "Supports brain and eye health",
      "Complete and balanced formula",
      "Grain-free recipe",
    ],
  },
  {
    id: 8,
    name: "hetcratehub Wet Cat Food - Salmon Recipe",
    category: "Cat Food",
    price: "2.89",
    reviews: "190",
    rating: "4.8",
    image: "/img/products/product-08.webp",
    images: ["/img/products/product-08.webp"],
    description: [
      "hetcratehub Salmon Recipe features wild-caught salmon as the star ingredient in this premium wet cat food.",
      "This omega-3 rich formula helps support healthy skin and a lustrous, shiny coat.",
      "Made with real salmon and wholesome vegetables without artificial preservatives or fillers.",
      "The savory flavor makes it a favorite among cats who love seafood.",
      "Provides excellent hydration through moisture-rich wet food.",
    ],
    Features: [
      "Wild-caught salmon #1 ingredient",
      "Omega-3 rich for coat health",
      "Grain-free formula",
      "No artificial preservatives",
      "Moisture-rich for hydration",
      "Made with whole food ingredients",
    ],
  },
  {
    id: 9,
    name: "hetcratehub Beef Chew Strip - 6 Inches",
    category: "Dog Treats",
    price: "1.78",
    reviews: "256",
    rating: "4.7",
    image: "/img/products/product-09.webp",
    images: ["/img/products/product-09.webp"],
    description: [
      "hetcratehub Beef Chew Strips are premium dog treats made from 100% real beef for a taste dogs love.",
      "These 6-inch beef strips are perfect for larger dogs or for splitting into smaller training rewards.",
      "Slow-roasted to perfection to bring out the natural flavor and tender texture.",
      "High in protein and free from artificial colors, flavors, and preservatives.",
      "A satisfying chew that helps clean teeth and massage gums.",
    ],
    Features: [
      "100% Angus beef",
      "Slow-roasted for flavor",
      "6-inch length ideal for big dogs",
      "No artificial additives",
      "High protein treat",
      "Helps promote dental health",
    ],
  },
  {
    id: 10,
    name: "hetcratehub Wet Kitten Food - Chicken Recipe",
    category: "Kitten Food",
    price: "4.09",
    reviews: "312",
    rating: "4.9",
    image: "/img/products/product-10.webp",
    images: ["/img/products/product-10.webp"],
    description: [
      "hetcratehub Wet Kitten Food Chicken Recipe is specially formulated for growing kittens with real chicken as the first ingredient.",
      "This nutrient-dense formula provides the extra calories and protein growing kittens need for healthy development.",
      "Enhanced with DHA for brain and eye development, making it ideal for young cats.",
      "Small, easy-to-eat bites perfect for kittens transitioning from mother's milk to solid food.",
      "Fortified with essential vitamins and minerals to support a strong immune system.",
    ],
    Features: [
      "Real chicken #1 ingredient",
      "Added DHA for brain development",
      "High protein for growth",
      "Small bite texture for kittens",
      "Immune-supporting vitamins",
      "Complete nutrition for kittens",
    ],
  },
  {
    id: 11,
    name: "hetcratehub Wet Cat Food - Tuna Recipe",
    category: "Cat Food",
    price: "4.19",
    reviews: "198",
    rating: "4.6",
    image: "/img/products/product-11.webp",
    images: ["/img/products/product-11.webp"],
    description: [
      "hetcratehub Tuna Recipe features premium tuna as the primary ingredient for a taste cats can't resist.",
      "This ocean-inspired wet cat food provides excellent protein and omega fatty acids.",
      "Made with simple, wholesome ingredients in a grain-free formula.",
      "The smooth texture is perfect for cats of all ages and encourages proper hydration.",
      "Crafted with real tuna that cats find absolutely irresistible.",
    ],
    Features: [
      "Premium tuna #1 ingredient",
      "Omega-rich formula",
      "Grain-free recipe",
      "No artificial preservatives",
      "Promotes healthy coat",
      "Moisture-rich wet food",
    ],
  },
  {
    id: 12,
    name: "hetcratehub Urinary Care Wet Cat Food - Ocean Whitefish Entrée",
    category: "Cat Food",
    price: "3.49",
    reviews: "267",
    rating: "4.5",
    image: "/img/products/product-12.webp",
    images: ["/img/products/product-12.webp"],
    description: [
      "hetcratehub Urinary Care Ocean Whitefish Entrée is formulated to support adult cats' urinary tract health.",
      "Specially formulated with controlled mineral levels to help maintain urinary tract health in adult cats.",
      "Features real ocean whitefish as the primary ingredient for great taste cats love.",
      "Promotes optimal urine pH levels to reduce the risk of urinary issues.",
      "Complete and balanced nutrition for daily feeding.",
    ],
    Features: [
      "Supports urinary tract health",
      "Controlled mineral levels",
      "Real ocean whitefish",
      "Optimal urine pH formula",
      "Veterinarian recommended",
      "Complete and balanced nutrition",
    ],
  },
  {
    id: 13,
    name: "hetcratehub Freeze-Dried Cat Food - Chicken & Lamb Feast",
    category: "Cat Food",
    price: "17.99",
    reviews: "223",
    rating: "4.6",
    image: "/img/products/product-13.webp",
    images: ["/img/products/product-13.webp"],
    description: [
      "hetcratehub Freeze-Dried Chicken & Lamb Feast is a premium raw cat food made with cage-free chicken and grass-fed lamb.",
      "Freeze-dried to preserve nutrients and natural flavor without the need for artificial preservatives.",
      "This high-protein formula mirrors a cat's natural diet in the wild.",
      "Made with simple, whole ingredients including chicken hearts, chicken livers, and lamb for complete nutrition.",
      "Can be served as a complete meal or as a delicious topper for dry food.",
    ],
    Features: [
      "Cage-free chicken and grass-fed lamb",
      "Freeze-dried for nutrient preservation",
      "High-protein raw nutrition",
      "No artificial preservatives",
      "Made with whole food ingredients",
      "Versatile feeding options",
    ],
  },
  {
    id: 14,
    name: "hetcratehub Wet Cat Food - Tuna Fillet with Prawns",
    category: "Cat Food",
    price: "1.27",
    reviews: "198",
    rating: "4.7",
    image: "/img/products/product-14.webp",
    images: ["/img/products/product-14.webp"],
    description: [
      "hetcratehub Tuna Fillet with Prawns features carefully selected fish as the #1 ingredient.",
      "This premium wet cat food is made with real tuna fillets and succulent prawns for exceptional taste.",
      "The recipe uses carefully selected ingredients for a simple, appealing meal.",
      "The combination of fish and seafood provides excellent protein and omega fatty acids.",
      "Free from artificial colors, preservatives, and unnecessary fillers.",
    ],
    Features: [
      "Carefully selected fish",
      "Real tuna fillets",
      "Added prawns for flavor",
      "No artificial additives",
      "High-quality protein source",
      "Made with simple ingredients",
    ],
  },
  {
    id: 15,
    name: "hetcratehub Wet Cat Food Topper - Rabbit Recipe",
    category: "Cat Food",
    price: "1.94",
    reviews: "312",
    rating: "4.8",
    image: "/img/products/product-15.webp",
    images: ["/img/products/product-15.webp"],
    description: [
      "hetcratehub Rabbit Recipe Wet Cat Food Topper is a savory broth-based topper designed to enhance any meal.",
      "Made with real rabbit pieces in a savory broth for an appealing taste and texture.",
      "Perfect for picky eaters or cats who need encouragement to drink more water.",
      "Can be served as a topper, mixer, or as a standalone treat.",
      "Grain-free formula with no artificial colors or preservatives.",
    ],
    Features: [
      "Real rabbit as first ingredient",
      "Bone broth base",
      "No artificial colors",
      "Grain-free formula",
      "Encourages hydration",
      "Versatile feeding options",
    ],
  },
  {
    id: 16,
    name: "hetcratehub Beef Chew Strip - 12 Inches",
    category: "Dog Treats",
    price: "2.97",
    reviews: "187",
    rating: "4.7",
    image: "/img/products/product-16.webp",
    images: ["/img/products/product-16.webp"],
    description: [
      "hetcratehub Beef Chew Strips in the 12-inch size are longer, thicker treats for big dogs who enjoy a substantial chew.",
      "Made from premium beef that is slow-roasted for maximum flavor and tenderness.",
      "These all-natural treats are free from hormones, steroids, and artificial additives.",
      "The extended length provides extended chewing entertainment and dental benefits.",
      "Single ingredient beef for a clean, protein-rich treat dogs adore.",
    ],
    Features: [
      "Premium beef",
      "12-inch length for big dogs",
      "Slow-roasted texture",
      "No hormones or steroids",
      "Single ingredient treat",
      "Long-lasting chew",
    ],
  },
  {
    id: 17,
    name: "hetcratehub Quinoa Care Cat Food - Urinary Duck",
    category: "Cat Food",
    price: "51.99",
    reviews: "234",
    rating: "4.6",
    image: "/img/products/product-17.webp",
    images: ["/img/products/product-17.webp"],
    description: [
      "hetcratehub Quinoa Care Urinary Duck is a wet cat food formulated to support urinary tract health.",
      "Features duck as the primary protein source combined with quinoa, a ancient grain rich in nutrients.",
      "The formula includes dried cranberry extract to help maintain healthy urinary tract function.",
      "Controlled mineral levels and optimal urine pH help reduce the risk of urinary issues.",
      "Made with natural ingredients and no artificial preservatives.",
    ],
    Features: [
      "Duck as primary protein",
      "Added quinoa nutrition",
      "Dried cranberry for urinary health",
      "Controlled mineral formula",
      "Optimal urine pH levels",
      "Veterinary-formulated recipe",
    ],
  },
  {
    id: 18,
    name: "hetcratehub Freeze-Dried Cat Food - Chicken Feast",
    category: "Cat Food",
    price: "29.99",
    reviews: "201",
    rating: "4.6",
    image: "/img/products/product-18.webp",
    images: ["/img/products/product-18.webp"],
    description: [
      "hetcratehub Freeze-Dried Chicken Feast is a premium raw cat food made with cage-free chicken and organs.",
      "Freeze-dried technology locks in nutrients and natural flavor without cooking or artificial preservatives.",
      "This complete and balanced raw diet provides cats with the protein they instinctively need.",
      "Made with chicken muscle meat, chicken liver, and chicken heart for authentic feline nutrition.",
      "Can be fed as a full meal or crumbled as a nutritious topper over dry food.",
    ],
    Features: [
      "Cage-free chicken",
      "Includes chicken organs",
      "Freeze-dried raw nutrition",
      "No artificial preservatives",
      "Complete and balanced",
      "High protein formula",
    ],
  },
  {
    id: 19,
    name: "hetcratehub Urinary Care Wet Cat Food - Turkey & Giblets Entrée",
    category: "Cat Food",
    price: "3.49",
    reviews: "276",
    rating: "4.8",
    image: "/img/products/product-19.webp",
    images: ["/img/products/product-19.webp"],
    description: [
      "hetcratehub Urinary Care Turkey & Giblets Entrée is formulated to support adult cats' urinary health.",
      "Made with real turkey and chicken giblets for a flavorful, protein-rich meal cats love.",
      "The special urinary health formula includes controlled mineral levels and optimal urine acidification.",
      "Helps maintain urinary tract health by reducing urinary pH and promoting adequate water intake.",
      "A complete daily option for cats that need urinary-care nutrition.",
    ],
    Features: [
      "Real turkey and giblets",
      "Urinary health formula",
      "Controlled mineral levels",
      "Optimal urine pH",
      "Designed for daily feeding",
      "Complete balanced nutrition",
    ],
  },
  {
    id: 20,
    name: "hetcratehub Freeze-Dried Soft Nibs for Cats - Chicken Entrée",
    category: "Cat Food",
    price: "36.12",
    reviews: "189",
    rating: "4.6",
    image: "/img/products/product-20.webp",
    images: ["/img/products/product-20.webp"],
    description: [
      "hetcratehub Freeze-Dried Soft Nibs Chicken Entrée is a raw cat food made from fresh chicken.",
      "The soft, tender texture is perfect for cats of all ages, including seniors who may have difficulty chewing.",
      "Freeze-dried to preserve nutrients and natural enzymes without cooking.",
      "Single animal protein source with no fillers, grains, or artificial ingredients.",
      "Provides cats with the raw nutrition they need for optimal health and vitality.",
    ],
    Features: [
      "Fresh chicken",
      "Soft texture for all ages",
      "Freeze-dried raw nutrition",
      "Single protein source",
      "No grains or fillers",
      "Retains natural enzymes",
    ],
  },
];

export default productData;
